import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const GradFairsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "GradFairsLinks" */
      './GradFairsLinks.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
